<a href="/magic/set/{{ magicSet.set.setCode! }}">
    <div class="flex flex-col rounded bg-ponder-dark card-shadow text-xs sm:text-sm">
        <div class="flex flex-row p-3 gap-2 text-faded-80 items-center hover:text-white">
            <div>
                <magic-set-icon [setCode]="magicSet.set.setCode!" [rarity]="rarity"></magic-set-icon>
            </div>
            <div class="flex flex-row truncate">
                {{ magicSet.set.setName! }} ({{ magicSet.set.setCode! | uppercase }})
            </div>
            <div class="grow">
            </div>
            @if (!isMobileScreen()) {
                <div class="pr-1">
                    {{ magicSet.collectedCount }} / {{ magicSet.set.distinctCardCount }}
                </div>
            }
            <div class="w-[6ch] text-right font-bold">
                {{ magicSet.percentage }}%
            </div>
        </div>
        <div class="w-full rounded-b shadow">
            <div class="text-xs h-[2px]" [style.width.%]="magicSet.percentage" [style.background-color]="rarityColor">
                
            </div>
        </div>
    </div>
</a>